import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=5bcd403c&"
import script from "./Preview.vue?vue&type=script&lang=ts&"
export * from "./Preview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports